//@flow
import * as React from 'react';
import { compose } from 'recompose';
import { themr, type ThemeType } from 'react-css-themr';
import { AppBar } from 'react-toolbox/lib/app_bar';
import UserMenuItem from 'common/components/core/menu/UserMenuItem';
import { connect } from 'react-redux';
import { AuthenticationActions } from 'common/modules/auth';
import UiSwitchIcon from 'common/components/core/ui_switcher/UiSwitcher';

import { FullScreenIcon } from 'common/components/core/full_screen_icon';
import theme from './HeaderWithLogout.scss';
import { sessionSelector } from 'common/redux/selectors/sessionSelector';
import {
    withRouter,
    type WithRouterProps
} from 'common/components/core/router';
import coreIds from 'common/tests/core/coreIds.json';
import { Box } from '@locus-taxy/neo-ui';
import { Session } from 'common/models/internal/Session';
import type { Dispatch } from 'redux';
import type { ProductType } from 'common/enums/Product';
import FullscreenHelper from 'common/helpers/FullscreenHelper';
import { ChatButton, selectIsChatVisible } from 'common/modules/chat';

export const appBarHeaderZIndex = 30;

type OwnProps = {
    children?: React.Node,
    className?: string,
    showFullScreenIcon?: boolean,
    showUiSwitchIcon: boolean,
    product: ProductType,
    isChatVisible: boolean,
    onRevert?: () => void,
    onUpgrade?: () => void
};

type Props = {
    ...OwnProps,
    ...WithRouterProps,
    session: Session,
    theme: ThemeType,
    dispatch: Dispatch<$FixMe>
};

type State = {
    isFullScreen: boolean
};
class HeaderWithLogout extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            isFullScreen: document.webkitIsFullScreen
        };
    }

    toggleFullScreen = isFullScreen => {
        this.setState({
            isFullScreen: !isFullScreen
        });
    };
    onLogout = () => {
        const { dispatch, location } = this.props;
        dispatch(
            AuthenticationActions.logoutFromLocation({
                currentLocation: location
            })
        );
    };
    render() {
        const {
            session,
            children,
            theme,
            className,
            showFullScreenIcon = true,
            showUiSwitchIcon,
            onUpgrade,
            onRevert,
            product,
            isChatVisible
        } = this.props;
        const { isFullScreen } = this.state;

        var personnel;
        var photo = '/img/user-photo-success.svg';
        if (session) {
            ({ personnel } = session);
            photo =
                personnel && personnel.photoUrl ? personnel.photoUrl : photo;
        }
        return (
            <Box sx={{ zIndex: appBarHeaderZIndex }}>
                <AppBar
                    flat
                    theme={theme}
                    className={className}
                    data-test-id={coreIds.dashboardHeader}
                >
                    {children}
                    {isChatVisible && <ChatButton />}
                    {showFullScreenIcon && FullscreenHelper.isSupported() ? (
                        <FullScreenIcon
                            isFullScreen={isFullScreen}
                            toggleFullScreen={this.toggleFullScreen}
                        />
                    ) : null}
                    {showUiSwitchIcon && (
                        <UiSwitchIcon
                            onRevert={onRevert}
                            onUpgrade={onUpgrade}
                            product={product}
                        />
                    )}
                    {personnel ? (
                        <UserMenuItem
                            userPhoto={photo}
                            onSignout={this.onLogout}
                            userName={personnel.name}
                            clientId={personnel.clientId}
                        />
                    ) : null}
                </AppBar>
            </Box>
        );
    }
}
const mapStateToProps = state => {
    return {
        session: sessionSelector(state),
        isChatVisible: selectIsChatVisible(state)
    };
};
const ConnectedHeaderWithLogout = (compose(
    withRouter,
    connect(mapStateToProps),
    themr('HeaderWithLogout', theme)
)(HeaderWithLogout): React.AbstractComponent<OwnProps>);

export { ConnectedHeaderWithLogout as HeaderWithLogout };
export default (ConnectedHeaderWithLogout: React.AbstractComponent<OwnProps>);
